export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4745.ba8c88b4.jpg";